import HTML from '../html'
import PropertyLister from './Finder/property-lister/controller'
import remoteServer from './Finder/remote-server'
import ViewModes from "./Finder/view-modes"

export default class ProjektList extends PropertyLister {

    constructor(rootBlock) {
        super(rootBlock)
        this.root = $(rootBlock)
        this.contentRoot = this.root.find('.projektList__content')
        this.listRoot = this.root.find('.projektList__content__list')
        this.projektID = this.root.data('property-projekt-id')
        this.viewMode = 'grid-mode'
        this.viewModes = new ViewModes()

        this.finderInstance = {
            viewMode: this.viewMode,
            contentRoot: this.contentRoot,
            viewModes: this.viewModes,
            setViewMode: mode => {
                this.viewModes.setActive(mode)
                return this
            },
        }

        this.finderInstance.viewModes.addMode({
            displayName: 'Grid view',
            slug: 'grid-mode',
            faIconSlug: 'fa-th-large',
            onModeOn: mode => { this.contentRoot.addClass(mode.slug) },
            onModeOff: mode => { this.contentRoot.removeClass(mode.slug) },
        })


        this.remoteServer = remoteServer()

        this.remoteServer.request(data => {
            this.manage(data).render()
        })
    }

    manage(data) {
        let currentProjekt = data.projekts.filter(projekt => projekt.wpid === this.projektID)
        let validProjekts = data.projekts.filter(projekt => Object.keys(projekt.city).length  && projekt.wpid !== this.projektID)
        let projekts = []
        let numOfProjekts = 3

        if (currentProjekt.length) {
            for (let projekt of validProjekts) {
                if (projekt.city.districts.length
                    && currentProjekt[0].city.districts.length
                    && projekt.city.districts[0].name === currentProjekt[0].city.districts[0].name
                    && projekt.props.status !== 'Slutsålt') {
                    projekts.push(projekt)
                }
                if (projekts.length === numOfProjekts) {
                    break
                }
            }

            if (projekts.length < numOfProjekts) {
                for (let projekt of validProjekts) {
                    if (projekt.city.name === currentProjekt[0].city.name && !projekts.includes(projekt) && projekt.props.status !== 'Slutsålt') {
                        projekts.push(projekt)
                    }
                    if (projekts.length === numOfProjekts) {
                        break
                    }
                }
            }

            if (projekts.length < numOfProjekts) {
                shuffleArray(validProjekts)
                for (let projekt of validProjekts) {
                    if (!projekts.includes(projekt) && projekt.props.status !== 'Slutsålt') {
                        projekts.push(projekt)
                    }
                    if (projekts.length === numOfProjekts) {
                        break
                    }
                }
            }


            if (!projekts.length) {
                $(this.contentRoot).hide()
                return this
            }
            this.props.projekts = projekts
        }

        return this
    }

    clearProjekts() {
        this.listRoot.empty()
        return this
    }

    fillProjekts() {
        if (this.props.projekts) {
            this.listRoot.append(
                this.view.projektsList(this.props.projekts),
            )
        }
        return this
    }

    render() {
        if (!this.props.projekts.length) {
            return this
        }
        this.clearProjekts().fillProjekts()
        return this
    }

}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

